import type { TranslationInterface } from '.';

export const SlovakLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Napíšte správu...',
  your_issue_has_been_resolved: 'Váš problém bol vyriešený!',
  new_conversation: 'Nová konverzácia',
  welcome_screen_title: 'Vitajte v našom zákazníckom chate',
  welcome_screen_description:
    'Sme tu, aby sme vám pomohli! Začnite konverzáciu a odpovieme vám čo najskôr.',
  your_name_placeholder: 'Vaše meno',
  your_email_placeholder: 'Vaša e-mailová adresa',
  start_chat_button: 'Hovoriť s podporou',
  start_chat_button_loading: 'Pripájanie...',
  i_need_more_help: 'Potrebujem ďalšiu pomoc',
  this_was_helpful: 'Toto bolo užitočné',
  optional: 'Voliteľné',
  no_conversations_yet: 'Zatiaľ žiadne konverzácie',
  back_to_conversations: 'Späť na konverzácie',
  closed_conversations: 'Uzavreté konverzácie',
  csat_title: 'Aká bola vaša konverzácia?',
  csat_submitted_title: 'Konverzáciu ste ohodnotili ako',
  csat_feedback_placeholder: 'Povedzte nám viac... (nepovinné)',
  follow_up_placeholder: 'Pokračovať…',
  companion_layout_label: 'Rozloženie',
  companion_layout_floating: 'Plávajúce',
  companion_layout_sidebar: 'Bočný panel',
  companion_layout_fullscreen: 'Celá obrazovka',
  companion_close: 'Zavrieť',
  companion_history: 'História konverzácií',
  companion_expand_chat: 'Rozbaliť chat',
  companion_sidebar_dock_label: 'Ukotvenie',
  companion_sidebar_side_label: 'Strana',
  companion_sidebar_left: 'Vľavo',
  companion_sidebar_right: 'Vpravo',
  companion_resize_chat: 'Zmeniť veľkosť chatu',
  scroll_to_bottom: 'Posunúť nadol',
  thinking: 'Premýšľam…',
  running: 'Prebieha…',
  steps: 'kroky',
  step_arguments: 'Argumenty',
  step_result: 'Výsledok',
  attach_files:
    'Priložiť obrázky, videá, PDF súbory alebo tabuľky (maximálna veľkosť 25 MB)',
  mark_page_active:
    'Kliknutím na čokoľvek na stránke to označíte — klávesom Esc akciu zrušíte',
  mark_page: 'Označte niečo na stránke a opýtajte sa na to',
  stop_response: 'Zastaviť odpoveď',
  copy_reply: 'Kopírovať odpoveď',
  mentions_empty: 'Žiadne zhody',
  copied: 'Skopírované',
  send_message: 'Odoslať správu',
  upload_failed: 'Nahrávanie zlyhalo: {error}',
  remove_attachment: 'Odstrániť prílohu',
  json_no_items: 'Žiadne položky',
  json_no_data: 'Žiadne údaje',
  json_no_chart_data: 'Žiadne údaje pre graf',
  json_unsupported: 'Nepodporované: {type}',
  json_see_less: 'Zobraziť menej',
  json_phone_agent: 'Telefónny agent',
  json_phone_agent_test: 'Vyskúšať na webe',
  page_context_remove: 'Odstrániť kontext stránky',
  json_see_more: 'Zobraziť ďalších {count}',
  queued_label: '{count} Vo fronte',
  remove_queued_message: 'Odstrániť správu z frontu',
  send_queued_now: 'Odoslať správy vo fronte teraz',
  turn_failed_message: 'Niečo sa pokazilo a odpoveď neprišla.',
  turn_failed_retry: 'Skúsiť znova',
  page_mark_hint: 'Kliknutím na čokoľvek to označíte',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Rámček',
  page_mark_shape_circle: 'Kruh',
  page_mark_shape_arrow: 'Šípka',
  page_mark_shape_bracket: 'Zátvorka',
  page_mark_shape_underline: 'Podčiarknutie',
  page_mark_shape_highlight: 'Zvýraznenie',
  page_mark_shape_strike_through: 'Prečiarknutie',
  page_mark_shape_crossed_off: 'Krížové prečiarknutie',
  page_mark_shape_aria: 'Tvar označenia: {shape}',
  page_mark_note_placeholder: 'Pridať poznámku… (Enter na priloženie)',
  page_mark_attach: 'Priložiť označenie',
  page_mark_remove: 'Odstrániť {label}',
  page_mark_region: 'Označená oblasť',
  page_mark_default_message: 'Čo je to?',
  file_rejected: 'Typ súboru nie je podporovaný alebo je súbor príliš veľký.',
  dictate: 'Diktovať',
  stop_dictation: 'Zastaviť diktovanie',
  dictation_mic_blocked: 'Na diktovanie povoľte prístup k mikrofónu',
  dictation_unavailable: 'Diktovanie momentálne nie je k dispozícii',
  questions_back: 'Späť',
  questions_next: 'Ďalej',
  questions_send: 'Odoslať',
  questions_type_answer: 'Napíšem to sám',
  questions_answer_placeholder: 'Napíšte svoju odpoveď…',
  close_conversation_title: 'Uzavrieť konverzáciu',
  close_conversation_description: 'Naozaj chcete túto konverzáciu uzavrieť?',
  close_conversation_cancel: 'Nie',
  close_conversation_confirm: 'Áno',
  dialog_close: 'Zavrieť',
  zoom_in: 'Priblížiť',
  zoom_out: 'Oddialiť',
  reset_zoom: 'Obnoviť priblíženie',
  support_chat_aria_label: 'Chat podpory',
};
